import React from "react";

const useCases = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
    title: 'Home Preparedness',
    desc: 'Know exactly what you have — ammo, water, medical supplies, and gear — all in one place. No guessing when it matters most.',
    num: '01',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    title: 'Hunting Season',
    desc: 'Track hunting ammo by type, trip, and firearm. Never dig through boxes the morning of a hunt wondering what you have left.',
    num: '02',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/>
        <line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/>
        <line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/>
      </svg>
    ),
    title: 'At the Range',
    desc: 'Log ammo usage and track round counts per session. Know exactly what calibers you burned through and when to restock before your next trip.',
    num: '03',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.07 4.93l-1.41 1.41M5.34 18.66l-1.41 1.41M20 12h2M2 12h2M19.07 19.07l-1.41-1.41M5.34 5.34L3.93 3.93M12 20v2M12 2v2"/>
      </svg>
    ),
    title: 'Reloaders',
    desc: 'Track powder, primers, brass, and dies. Know your component inventory at a glance and never start a session short-handed.',
    num: '04',
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
      </svg>
    ),
    title: 'Competitive Shooting',
    desc: 'Monitor match prep and usage trends. Plan ahead so you never run short before a major event.',
    num: '05',
  },
];

const UseCasesSection: React.FC = () => {
  return (
    <section id="use-cases" className="w-full bg-[#000000] py-24 px-4">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="mb-16">
          <p className="text-xs font-bold uppercase tracking-widest text-[#3b82f6] mb-3">Use Cases</p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <h2 className="text-4xl md:text-5xl font-extrabold leading-tight text-white max-w-lg">
              Built for the Way<br />You Prepare
            </h2>
            <p className="text-[#a3a3a3] max-w-sm md:text-right leading-relaxed">
              Whether you're a prepper, hunter, reloader, or range shooter — AmmoPantryAI keeps your entire inventory organized and private.
            </p>
          </div>
        </div>

        {/* Top divider */}
        <div className="w-full h-px bg-white/10 mb-0" />

        {/* Use case rows */}
        <div className="divide-y divide-white/10">
          {useCases.map((uc) => (
            <div
              key={uc.num}
              className="group flex flex-col sm:flex-row sm:items-center gap-4 py-8 hover:bg-white/[0.02] transition-colors rounded-lg -mx-4 px-4"
            >
              {/* Number */}
              <span className="text-xs font-mono text-white/20 w-8 flex-shrink-0 hidden sm:block">
                {uc.num}
              </span>

              {/* Icon */}
              <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-[#3b82f6]/10 border border-[#3b82f6]/20 flex items-center justify-center text-[#3b82f6]">
                {uc.icon}
              </div>

              {/* Title */}
              <div className="sm:w-48 flex-shrink-0">
                <div className="text-lg font-bold text-white group-hover:text-[#3b82f6] transition-colors">
                  {uc.title}
                </div>
              </div>

              {/* Desc */}
              <div className="text-[#a3a3a3] leading-relaxed flex-1 text-sm md:text-base">
                {uc.desc}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom divider */}
        <div className="w-full h-px bg-white/10 mt-0" />

      </div>
    </section>
  );
};

export default UseCasesSection;
